import React from "react";
import { __ } from "../../../../../lib/translate";
import useWindowDimensions from "../../../../../lib/hooks/useWindowDimensions";
import { MOBILE_WIDTH_BREAKPOINT } from "../../../../../config/constants";
import EmptyDesktopIcon from "../../../../../../root/img/grid/empty-state/myshares-desktop.svg";
import EmptyMobileIcon from "../../../../../../root/img/grid/empty-state/myshares-mobile.svg";
import {
    EmptyStateMessage,
    EmptyStateMessageSubTitle,
    EmptyStateMessageTitle,
    EmptyStateWrapper,
    ImageContainer
} from "../styles";
import styled from "styled-components";

const MyShares = ({ noItemsLabel }) => {
    const { bodyWidth } = useWindowDimensions();
    const isMobile = bodyWidth < MOBILE_WIDTH_BREAKPOINT;

    return (
        <EmptyStateWrapper $isMobile={isMobile}>
            <EmptyStateMessage $isMobile={isMobile}>
                <EmptyStateMessageTitle>
                    {__(...noItemsLabel)}
                </EmptyStateMessageTitle>
                <EmptyStateMessageSubTitleCustom>
                    {__(
                        "myshares_empty_message",
                        'Collaborate with your team in shared folders. Use the option "Invite to folder" to share private folders with other pCloud users.'
                    )}
                </EmptyStateMessageSubTitleCustom>
            </EmptyStateMessage>

            <ImageContainer $isMobile={isMobile}>
                {!isMobile && <EmptyDesktopIcon />}
                {isMobile && <EmptyMobileIcon />}
            </ImageContainer>

            <div />
        </EmptyStateWrapper>
    );
};

export default MyShares;

const EmptyStateMessageSubTitleCustom = styled(EmptyStateMessageSubTitle)`
    padding: 16px 0;
`;
